module.exports = __webpack_public_path__ + "static/media/007.a3c4459a.jpg";